import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconDoubleChat: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0139 11.8653C13.9826 11.768 13.958 11.6233 14.0187 11.4913C14.3333 10.8167 14.4993 10.0707 14.4993 9.33333C14.4993 7.294 13.2626 5.43533 11.408 4.62C10.614 2.78666 8.78794 1.5 6.6666 1.5C3.8186 1.5 1.50059 3.81735 1.50059 6.66602C1.50059 7.40802 1.66525 8.15466 1.97992 8.83C2.02725 8.93066 2.02921 9.06202 1.98854 9.19202L1.55267 10.4893C1.43 10.8573 1.52522 11.2566 1.80055 11.532C1.99655 11.728 2.25527 11.832 2.52061 11.832C2.62861 11.832 2.738 11.8147 2.84466 11.7793L4.13324 11.346C4.27057 11.302 4.40193 11.3047 4.50726 11.354C4.54059 11.3693 4.57663 11.38 4.60996 11.3953C5.42463 13.2567 7.2886 14.4993 9.33327 14.4993C10.0706 14.4993 10.8172 14.3333 11.4879 14.0207C11.6232 13.9587 11.7686 13.9833 11.8613 14.0133L13.1573 14.4473C13.526 14.568 13.9247 14.4727 14.1993 14.198C14.4733 13.9233 14.5686 13.5247 14.4466 13.1533L14.0139 11.8653ZM4.32399 10.316C4.15932 10.316 3.98989 10.3426 3.82122 10.3966L2.50059 10.8067L2.93858 9.50269C3.05991 9.12202 3.03922 8.73001 2.88389 8.40401C2.63322 7.86401 2.50059 7.26266 2.50059 6.66532C2.50059 4.36799 4.36994 2.49935 6.6666 2.49935C8.96327 2.49935 10.8326 4.36799 10.8326 6.66532C10.8326 8.96266 8.96327 10.8313 6.6666 10.8313C6.06927 10.8313 5.4679 10.6987 4.9319 10.45C4.74523 10.3613 4.53932 10.316 4.32399 10.316ZM13.0654 12.1787L13.4713 13.4987L12.1739 13.064C11.7966 12.9413 11.4046 12.9587 11.0686 13.1127C10.526 13.3653 9.92529 13.4993 9.33262 13.4993C7.96462 13.4993 6.73524 12.844 5.96657 11.7773C6.19857 11.8093 6.4326 11.8313 6.6666 11.8313C9.5146 11.8313 11.8326 9.51399 11.8326 6.66532C11.8326 6.43199 11.812 6.20401 11.7813 5.97868C12.834 6.75068 13.4993 7.99268 13.4993 9.33268C13.4993 9.92535 13.3659 10.5253 13.1113 11.0713C12.9579 11.406 12.9414 11.798 13.0654 12.1787Z"
      fill={color}
    />
  </svg>
);

export default IconDoubleChat;
